import React from 'react'
import './ImageLoadingOverlay.scss' // Assuming you will create a CSS file for styling
import { useTranslation } from 'react-i18next'

interface ImageLoadingOverlayProps {
  visible?: boolean
}

export function ImageLoadingOverlay({ visible }: ImageLoadingOverlayProps) {
  const { t } = useTranslation()

  return (
    <div className="image-composer-overlay" style={visible ? { display: 'flex' } : { display: 'none' }}>
      <div className="image-composer-overlay-content">{t('Image:generating')}</div>
    </div>
  )
}
